import type { AxiosRequestConfig, AxiosResponse } from 'axios';
import { useAuth } from 'react-oidc-context';

export function useWithAccessToken<T>(
  operation: (config: AxiosRequestConfig) => Promise<AxiosResponse<T>>,
): () => Promise<AxiosResponse<T>> {
  const auth = useAuth();
  const accessToken = auth.user?.access_token;
  return () => operation({ headers: { Authorization: `Bearer ${accessToken}` } });
}
